import { useState, useCallback } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimeField } from "@mui/x-date-pickers/DateTimeField";
import { SingleInputDateTimeRangeField } from "@mui/x-date-pickers-pro/SingleInputDateTimeRangeField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import "moment/locale/it";

import styles from "./dt.module.scss";
function isValidRange(v) {
  return v && v[0] && v[1];
}

const now = moment();
const getValue = (value, isRange) => {
  if (value) {
    if (isRange) {
      const [d1, d2] = value.split("÷");
      return [moment(d1), moment(d2)];
    } else {
      return moment(value);
    }
  }

  return isRange ? [now, now] : now;
};

export default function DateTime(props) {
  const { handleChange, value, isRange, errored } = props;
  const [_value, setValue] = useState(() => getValue(value, isRange));

  const onChange = useCallback(
    (value) => {
      if (!value || (isRange && !isValidRange(value))) return;

      // .utcOffset(0, true)
      let ret = isRange
        ? `${value[0].toISOString()}÷${value[1].toISOString()}`
        : `${value.toISOString()}`;

      handleChange(ret);
      setValue(value);
    },
    [handleChange, isRange]
  );

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="it">
      {isRange ? (
        <SingleInputDateTimeRangeField
          value={_value}
          onChange={onChange}
          error={errored}
          hiddenLabel={true}
          className={styles.range}
        />
      ) : (
        <DateTimeField
          value={_value}
          onChange={onChange}
          error={errored}
          hiddenLabel={true}
          className={styles.single}
        />
      )}
    </LocalizationProvider>
  );
}
